export default {
	'view-details': 'View details'
}